import { render, staticRenderFns } from "./#detail-edit.vue?vue&type=template&id=5c7c2eb9&"
import script from "./#detail-edit.vue?vue&type=script&lang=js&"
export * from "./#detail-edit.vue?vue&type=script&lang=js&"
import style0 from "./#detail-edit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports